<template>
  <div class="quality quality-submit">
    <z-steps :active="1">
      <z-step
        class="step"
        v-for="(item, index) in horizontal"
        :key="index"
        :title="item.title"
        :image-active="item.imageActive"
        :image-deactive="item.imageDeactive"
      />
    </z-steps>

    <z-form label-width="100px" @submit="onSubmit" @failed="onFailed">
      <z-field
        v-model="bizName"
        name="bizName"
        label="企业名称"
        label-width="100px"
        placeholder="请输入认证企业名称"
        readonly
      />

      <z-field
        v-model="creditCode"
        name="creditCode"
        label="社会信用代码"
        label-width="100px"
        placeholder="请输入认证社会信用代码"
        readonly
      />

      <z-field
        readonly
        clickable
        name="permitType"
        :value="permitType"
        label="许可证类型"
        placeholder="点击选择许可证类型"
        label-width="100px"
        @click="showPicker = true"
      />
      <z-popup v-model="showPicker" position="bottom">
        <z-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </z-popup>

      <z-field
        v-model="permitCode"
        name="permitCode"
        label="许可证编号"
        label-width="100px"
        placeholder="请输入许可证编号"
      />

      <!-- <section class="quality-evidence">
        <capture-upload
          @uploaded="UploadedEvi"
          type="evidence"
          img="e549152d-2a15-472c-89e5-074007567d9b.png"
        />
      </section> -->

      <section class="upload-area">
        <evidence-upload-item class="evidence" type="front" tip="点击上传彩色原件或加盖公司公章的复印件" @uploaded="UploadedEvi">
          <div class="sample-cover"></div>
        </evidence-upload-item>
      </section>

      <z-button-group>
        <z-button type="primary" btn-class="bottombtn" loading-text="提交中..." native-type="submit" :disabled="disabled" :loading="loading">确认提交</z-button>
      </z-button-group>
    </z-form>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Step, Steps, Field, Button, ButtonGroup, Toast, Form, Popup, Picker } from '@zz-common/zz-ui'
// import { lego } from '@zz-common/lego'
// import CaptureUpload from '../../PayMoney/Submit/CaptureUpload/CaptureUpload'
// import MediaUploadItem from '../../RealAuth/MediaUploadItem/MediaUploadItem';
import EvidenceUploadItem from '../../cloudInspection/MediaUploadItem/MediaUploadItem';

import { queryParams } from '../../../lib/utils'
import { getbizlicense, submitBizPermit, getbizpermittype } from '../../../api/resourceApi'

const query = queryParams()

export default {
  name: 'QualityPermit',
  data() {
    return {
      sourceCode: query.sourceCode || this.$route.query.sourceCode || 'unknow',
      loading: false,
      bizName: '', //企业名称
      creditCode: '', //统一社会信用代码
      columns: ['个体工商营业执照', '企业法人营业执照'],
      columnsObj: { 个体工商营业执照: '1', 企业法人营业执照: '2' },
      permitType: '', //许可证类型
      permitCode: '', //许可证编码
      permitPic: '', //许可证图片
      showPicker: false,
      horizontal: [
        {
          title: '营业执照',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        },
        {
          title: '经营许可',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        },
        {
          title: '提交成功',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        }
      ]
    }
  },
  computed: {
    disabled() {
      return (
        this.permitType === '' ||
          this.permitCode === '' ||
          this.permitType === '' ||
          this.permitPic === ''
      )
    }
  },
  components: {
    zStep: Step,
    zSteps: Steps,
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zField: Field,
    zForm: Form,
    EvidenceUploadItem,
    zPopup: Popup,
    zPicker: Picker
  },
  methods: {
    async getDetial() {
      const { bizName, creditCode, hasLicense } = await getbizlicense();
      if (!+hasLicense) {
        const targetUrl = `https://feentry.zhuanzhuan.com/QualityAppeal?clientid=QualityLicense&sourceCode=${this.sourceCode}`
        native.skipToUrl({ targetUrl, needClose: '1' })
      }
      this.bizName = bizName;
      this.creditCode = creditCode;
    },
    async getTypeList() {
      const { list = [] } = await getbizpermittype();
      this.columns = list.map(({ label }) => label);
      this.columnsObj = list.reduce((cur, per) => {
        const { label, value } = per;
        cur[label] = value
        return cur
      }, {});
    },
    onConfirm(permitType) {
      this.permitType = permitType;
      this.showPicker = false;
    },
    onSubmit(values) {
      console.log('submit', values);
      const { permitType, permitCode } = values;
      const params = {
        permitCode,
        permitPic: this.permitPic,
        permitType: this.columnsObj[permitType],
        sourceCode: this.sourceCode
      }
      if (this.disabled) return Toast('请填写所有内容再提交')
      this.loading = true;
      submitBizPermit(params)
        .then((_res) => {
          this.loading = false
          Toast('提交成功')
          this.toSuccess();
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
        })
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
      Toast('failed');
    },
    UploadedEvi(rst) {
      this.permitPic = rst
    },
    toSuccess() {
      setTimeout(() => {
        native.skipToUrl({
          targetUrl: 'https://feentry.zhuanzhuan.com/QualityAppeal?clientid=QualitySuccess&status=deal',
          needClose: '1'
        })
      }, 300)
    }
  },
  mounted() {
    native.setTitle({
      title: '资质提交'
    })
    this.getDetial();
    this.getTypeList();
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
